import { render, staticRenderFns } from "./AuthLoginForm.vue?vue&type=template&id=ecfa52b4&scoped=true"
import script from "./AuthLoginForm.vue?vue&type=script&lang=js"
export * from "./AuthLoginForm.vue?vue&type=script&lang=js"
import style0 from "./AuthLoginForm.vue?vue&type=style&index=0&id=ecfa52b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecfa52b4",
  null
  
)

export default component.exports